import { SortableContext } from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Task } from "./dragable.component";
import GlimpseCard from "components/card/card.component";
import { IMyCareersPrioritize } from "interfaces/OnbaordingInterface";
import { UniqueIdentifier } from "@dnd-kit/core";
import { CareerCategory } from "enums/glimps.enums";
import "./scroll.css";
interface IDragCol {
  column: {
    category: UniqueIdentifier;
    title: string;
    subtitle: string;
  };
  tasks: IMyCareersPrioritize[];
  totalTopThree: number;
  onboardingSorted?: boolean;
  showUnsortedError?: boolean;
}
export const Column = ({
  column,
  tasks,
  totalTopThree,
  onboardingSorted,
  showUnsortedError,
}: IDragCol) => {
  const taskIds = tasks.map(({ id }: any) => id);
  const { setNodeRef, attributes, listeners, transform, transition } =
    useSortable({
      id: column.category,
      data: {
        type: "Column",
        column,
      },
    });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  const isUnsorted = column.category === CareerCategory.unsorted;
  const isTopThree = column.category === CareerCategory.top_three;
  const isWatchList = column.category === CareerCategory.watch_list;
  const isDiscard = column.category === CareerCategory.discard;

  const getDivsBasedOnTasksLength = (
    totalLength: number,
    tasksLength: number
  ) => {
    const divs: JSX.Element[] = [];
    const numberOfDivs = totalLength - tasksLength;

    for (let i = 0; i < numberOfDivs; i++) {
      divs.push(
        <div
          key={i}
          className="w-full rounded-full h-[38px] border border-dashed border-border"
        />
      );
    }
    return divs;
  };

  return (
    <GlimpseCard
      className={`!h-auto ${isUnsorted && "p-0 bg-transparent shadow-none"}`}
      title={
        onboardingSorted && isUnsorted ? "" : column.title
      }
      titleClass={`${!onboardingSorted && isUnsorted
        ? "text-display-lg text-brand font-bold"
        : "text-body-emphasis text-brand"
        }`}
      subtitle={isUnsorted ? "" : column.subtitle}
      subtitleClass="text-body-sm text-text-muted truncate"
    >
      <main
        id={column.title}
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        className={`flex ${isUnsorted ? "flex-row flex-wrap" : "flex-col"
          } gap-2 py-2 px-0`}
      >
        <SortableContext items={taskIds}>
          {tasks.map((task: any, index: number) => (
            <Task
              key={task.id}
              task={task}
              index={index}
              totalTopThree={totalTopThree}
              onboardingSorted={onboardingSorted}
              showUnsortedError={showUnsortedError}
            />
          ))}
        </SortableContext>
        {/* Placeholder rows */}
        <span className={`${onboardingSorted && "hidden"} ${isUnsorted && "hidden"} contents`}>
          {isTopThree &&
            tasks.length < 3 &&
            getDivsBasedOnTasksLength(3, tasks.length)}
          {(isWatchList || isDiscard) &&
            tasks.length < 3 &&
            getDivsBasedOnTasksLength(3, tasks.length)}
        </span>
      </main>
    </GlimpseCard>
  );
};
